import ModalBase from "modals/base/ModalBase";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import NiceModal from "@ebay/nice-modal-react";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import OrderListRow from "routes/account/mypage/order/OrderListRow";
import Dummy from "components/Dummy";
import style from "./PurchaseOrderModal.module.css";
import { style as buttonStyle } from "components/buttons/AdminCustomButton";
import P from "components/P";
import Center from "layouts/wrapper/Center";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Inline from "layouts/container/Inline";
import AdminImage from "components/Image/AdminImage";
import AdminCustomButton from "components/buttons/AdminCustomButton";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import InputTextarea from "components/inputs/InputTextarea";
import InputText from "components/inputs/InputText";
import { adminRequester } from "App";
import { _ } from "core-js";
import InputNumber from "components/inputs/InputNumber";

const OrderDetailModal = NiceModal.create((props, ref) => {
  const modal = useRef();
  const [withHeader, withFooter] = [true, false];
  const { isMobile } = useContext(BrowserDetectContext);
  const { t } = useTranslation();
  const [width, height] = [isMobile ? "100%" : "730px", "70vh"];
  const withCloseButton = true;
  const clickOutsideToClose = true;
  const title = t("orderDetail");
  const { data } = props;
  const buttonText = "close";
  const [editable, setEditable] = useState(false);
  const [items, setItems] = useState([]);
  const inputs = useRef([]);
  const getDate = (date) => {
    date = new Date(date);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(date.getDate()).padStart(2, "0")} ${String(
      date.getHours()
    ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
  };

  useEffect(() => {
    if (data) {
      setItems([
        ...data.items.map((item) => {
          return { ...item };
        }),
      ]);
    }
  }, [data]);
  const addressKrModalClick = () => {
    NiceModal.show("addressKr", { onCallback: addressKrCallback });
  };
  const addressKrCallback = (dataFromModal) => {
    if (dataFromModal) {
      // setFormData(prev => ({
      //   ...prev,
      const address1 = dataFromModal.address;
      const postalCode = dataFromModal.zonecode;
      // }));
      // ref를 통한 값 설정
      if (inputs.current[1]) inputs.current[1].setValue(postalCode);
      if (inputs.current[2]) inputs.current[2].setValue(address1);
      if (inputs.current[3]) inputs.current[3].empty();
    }
  };
  const save = () => {
    adminRequester.editOrder(
      data.id,
      {
        message: inputs.current[4]?.getValue?.(),
        shipping_address: {
          ...data.shipping_address,
          first_name: inputs.current[0]?.getValue?.(),
          postal_code: inputs.current[1]?.getValue?.(),
          address_1: inputs.current[2]?.getValue?.(),
          address_2: inputs.current[3]?.getValue?.(),
        },
        metadata: _.merge(data.metadata, {
          memo: inputs.current[5]?.getValue?.(),
          shipping: inputs.current[6]?.getValue?.(),
        }),
        items: items.map((item) => ({
          id: item.id,
          variant: { product_id: item.variant.product_id },
          unit_price: item.unit_price,
          quantity: item.quantity,
        })),
        payment_id: data.payments?.[0]?.id,
        point: data.metadata?.point || 0,
      },
      () => {
        props?.onSuccess?.();
        modal.current.close();
      }
    );
  };
  const reset = () => {
    setItems([
      ...data.items.map((item) => {
        return { ...item };
      }),
    ]);
    setEditable(false);
  };
  return (
    <ModalBase
      ref={modal}
      width={width}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      withCloseButton={withCloseButton}
      clickOutsideToClose={clickOutsideToClose}
      title={title}
      buttonText={buttonText}
    >
      <div className={style.wrap} style={{ padding: 15 }}>
        <VerticalFlex height="100%">
          <VerticalFlex gap={10}>
            <HorizontalFlex justifyContent="flex-start">
              <FlexChild>
                <FlexChild width="100px">
                  <P weight="bold">주문일</P>
                </FlexChild>
                <FlexChild width="max-content">
                  <P>{getDate(data.created_at)}</P>
                </FlexChild>
              </FlexChild>
              <FlexChild>
                <FlexChild width="100px">
                  <P weight="bold">결제일</P>
                </FlexChild>
                <FlexChild width="max-content">
                  <P>
                    {data?.payments?.length > 0 &&
                    data?.payment_status !== "awaiting"
                      ? getDate(data?.payments?.[0]?.updated_at)
                      : "결제정보없음"}
                  </P>
                </FlexChild>
              </FlexChild>
            </HorizontalFlex>
            <HorizontalFlex justifyContent="flex-start">
              <FlexChild width="100px">
                <P weight="bold">주문코드</P>
              </FlexChild>
              <FlexChild width="max-content">
                <P
                  cursor
                  textHover
                  onClick={() => {
                    navigator.clipboard.writeText(data.id);
                    toast.success("주문코드를 복사했습니다", {
                      autoClose: 1000,
                      position: "bottom-center",
                    });
                  }}
                >
                  {data.id}
                </P>
              </FlexChild>
            </HorizontalFlex>
            <HorizontalFlex justifyContent="flex-start">
              <FlexChild>
                <FlexChild width="100px">
                  <P weight="bold">주문자</P>
                </FlexChild>
                <FlexChild width="max-content">
                  <P>
                    {`${
                      data?.customer?.first_name ? data.customer.first_name : ""
                    }${
                      data?.customer?.first_name && data.customer.last_name
                        ? " "
                        : ""
                    }${
                      data?.customer?.last_name ? data.customer.last_name : ""
                    }(${data?.customer?.email ? data.customer.email : ""})`}
                  </P>
                </FlexChild>
              </FlexChild>
              <FlexChild>
                <FlexChild width="100px">
                  <P weight="bold">회원등급</P>
                </FlexChild>
                <FlexChild width="max-content">
                  <P>{data?.customer?.groups?.[0]?.name || "사업자회원"}</P>
                </FlexChild>
              </FlexChild>
            </HorizontalFlex>

            <HorizontalFlex justifyContent="flex-start">
              <FlexChild width="100px">
                <P weight="bold">상품</P>
              </FlexChild>
              <FlexChild>
                <div
                  style={{
                    height: 300,
                    border: "1px solid black",
                    width: "100%",
                    overflowY: "auto",
                    padding: 10,
                  }}
                >
                  <VerticalFlex gap={10}>
                    {items
                      .sort((i1, i2) =>
                        `${i1.variant.product.title}`.localeCompare(
                          `${i2.variant.product.title}`
                        )
                      )
                      .map((item) => (
                        <HorizontalFlex key={item?.id} gap={10}>
                          <FlexChild width="max-content">
                            <AdminImage src={item?.thumbnail} size={40} />
                          </FlexChild>
                          <FlexChild>
                            <VerticalFlex flexStart>
                              <FlexChild width="max-content">
                                <P>{item?.variant?.product?.title}</P>
                              </FlexChild>
                              <FlexChild width="max-content">
                                <P>
                                  {"     - "}
                                  {item?.variant?.title}
                                </P>
                              </FlexChild>
                            </VerticalFlex>
                          </FlexChild>
                          <FlexChild width="60px">
                            {item.unit_price > 0 ? (
                              <P>{item.unit_price.toLocaleString("ko-kr")}</P>
                            ) : (
                              <P color="#09B3F5">(증정)</P>
                            )}
                          </FlexChild>
                          <FlexChild width="max-content">
                            <P>X</P>
                          </FlexChild>
                          <FlexChild width="60px">
                            {editable ? (
                              <InputText
                                validable={false}
                                numberOnly
                                style={{ fontSize: 14, padding: 5 }}
                                value={item.quantity}
                                max={5}
                                onChange={(e) => (item.quantity = e)}
                              />
                            ) : (
                              <P>{item.quantity}</P>
                            )}
                          </FlexChild>
                        </HorizontalFlex>
                      ))}
                  </VerticalFlex>
                </div>
              </FlexChild>
            </HorizontalFlex>
            <HorizontalFlex justifyContent="flex-start">
              <FlexChild width="100px">
                <P weight="bold" alignItems="flex-start">
                  배송지 정보
                </P>
              </FlexChild>
              <FlexChild width="max-content">
                <div
                  style={{
                    border: "1px solid black",
                    width: "585px",
                    padding: 10,
                  }}
                >
                  <VerticalFlex gap={5}>
                    <HorizontalFlex justifyContent="flex-start">
                      <FlexChild width="100px">
                        <P>받는분</P>
                      </FlexChild>
                      <FlexChild width="max-content">
                        {editable ? (
                          <InputText
                            validable={false}
                            ref={(el) => (inputs.current[0] = el)}
                            style={{ fontSize: 14, padding: 5 }}
                            value={`${
                              data?.shipping_address?.company
                                ? data?.shipping_address?.company.replace(
                                    "default",
                                    ""
                                  )
                                : ""
                            }${
                              data?.shipping_address?.company &&
                              data?.shipping_address?.company !== "default" &&
                              (data?.shipping_address?.first_name ||
                                data?.shipping_address?.last_name)
                                ? " "
                                : ""
                            }${
                              data?.shipping_address?.first_name ||
                              data?.shipping_address?.last_name
                                ? `${data?.shipping_address?.first_name &&
                                    data?.shipping_address?.first_name}${
                                    data?.shipping_address?.first_name &&
                                    data?.shipping_address?.last_name
                                      ? " "
                                      : ""
                                  }${
                                    data?.shipping_address?.last_name
                                      ? data?.shipping_address?.last_name
                                      : ""
                                  }`
                                : ""
                            }`}
                          />
                        ) : (
                          <P>
                            {`${
                              data?.shipping_address?.company
                                ? data?.shipping_address?.company.replace(
                                    "default",
                                    ""
                                  )
                                : ""
                            }${
                              data?.shipping_address?.company &&
                              data?.shipping_address?.company !== "default" &&
                              (data?.shipping_address?.first_name ||
                                data?.shipping_address?.last_name)
                                ? " "
                                : ""
                            }${
                              data?.shipping_address?.first_name ||
                              data?.shipping_address?.last_name
                                ? `${data?.shipping_address?.first_name &&
                                    data?.shipping_address?.first_name}${
                                    data?.shipping_address?.first_name &&
                                    data?.shipping_address?.last_name
                                      ? " "
                                      : ""
                                  }${
                                    data?.shipping_address?.last_name
                                      ? data?.shipping_address?.last_name
                                      : ""
                                  }`
                                : ""
                            }`}
                          </P>
                        )}
                      </FlexChild>
                    </HorizontalFlex>
                    <HorizontalFlex justifyContent="flex-start">
                      <FlexChild width="100px">
                        <P>우편번호</P>
                      </FlexChild>
                      <FlexChild width="max-content">
                        {editable ? (
                          <InputText
                            validable={false}
                            readOnly
                            style={{ fontSize: 14, padding: 5 }}
                            ref={(el) => (inputs.current[1] = el)}
                            value={data?.shipping_address?.postal_code}
                          />
                        ) : (
                          <P>
                            {`${
                              data?.shipping_address?.postal_code
                                ? `${data?.shipping_address?.postal_code}`
                                : ""
                            }`}
                          </P>
                        )}
                      </FlexChild>
                    </HorizontalFlex>
                    <HorizontalFlex justifyContent="flex-start">
                      <FlexChild width="100px">
                        <P>주소</P>
                      </FlexChild>
                      <FlexChild width="max-content">
                        {editable ? (
                          <InputText
                            validable={false}
                            readOnly
                            style={{ fontSize: 14, padding: 5 }}
                            ref={(el) => (inputs.current[2] = el)}
                            value={data?.shipping_address?.address_1}
                          />
                        ) : (
                          <P>
                            {`${
                              data?.shipping_address?.address_1
                                ? data?.shipping_address?.address_1
                                : ""
                            }`}
                          </P>
                        )}
                      </FlexChild>
                      {editable ? (
                        <>
                          <FlexChild width="max-content" padding={"0 0 0 10px"}>
                            <AdminCustomButton
                              onClick={addressKrModalClick}
                              style={buttonStyle.blue}
                              text="우편번호 찾기"
                            />
                          </FlexChild>
                        </>
                      ) : (
                        <></>
                      )}
                    </HorizontalFlex>
                    <HorizontalFlex justifyContent="flex-start">
                      <FlexChild width="100px">
                        <P>상세주소</P>
                      </FlexChild>
                      <FlexChild width="450px">
                        {editable ? (
                          <InputText
                            validable={false}
                            style={{ fontSize: 14, padding: 5 }}
                            ref={(el) => (inputs.current[3] = el)}
                            value={data?.shipping_address?.address_2}
                          />
                        ) : (
                          <P>
                            {`${
                              data?.shipping_address?.address_2
                                ? data?.shipping_address?.address_2
                                : ""
                            }`}
                          </P>
                        )}
                      </FlexChild>
                    </HorizontalFlex>
                    <HorizontalFlex
                      justifyContent="flex-start"
                      alignItems="flex-start"
                    >
                      <FlexChild width="100px">
                        <P>메시지</P>
                      </FlexChild>
                      <FlexChild width="450px">
                        {editable ? (
                          <InputText
                            validable={false}
                            style={{ fontSize: 14, padding: 5 }}
                            ref={(el) => (inputs.current[4] = el)}
                            value={data.message}
                          />
                        ) : (
                          <P>{`${data?.message ? data.message : "없음"}`}</P>
                        )}
                      </FlexChild>
                    </HorizontalFlex>
                  </VerticalFlex>
                </div>
              </FlexChild>
            </HorizontalFlex>
            <HorizontalFlex justifyContent="flex-start">
              <FlexChild>
                <FlexChild width="100px">
                  <P weight="bold">배송상태</P>
                </FlexChild>
                <FlexChild width="max-content">
                  <P>{t(data.fulfillment_status)}</P>
                </FlexChild>
              </FlexChild>
              <FlexChild>
                <FlexChild width="100px">
                  <P weight="bold">운송장 번호</P>
                </FlexChild>
                <FlexChild width="max-content">
                  {editable ? (
                    <InputText
                      validable={false}
                      style={{ fontSize: 14, padding: 5 }}
                      ref={(el) => (inputs.current[6] = el)}
                      value={data?.metadata?.shipping}
                    />
                  ) : (
                    <P
                      textHover
                      cursor
                      onClick={() => {
                        const trackingNumber = data.metadata?.shipping; // 운송장 번호 가져오기
                        if (!trackingNumber) {
                          toast.error(t("운송장 번호가 존재하지 않습니다."), {
                            autoClose: 1000,
                            position: toast.POSITION.BOTTOM_CENTER,
                          });
                          return;
                        } else {
                          const trackingUrl = `https://trace.cjlogistics.com/next/tracking.html?wblNo=${trackingNumber.replaceAll(
                            "-",
                            ""
                          )}`;

                          // 팝업창 옵션 설정
                          const popupOptions =
                            "width=800,height=800,scrollbars=yes,resizable=yes";

                          // 팝업창 열기
                          window.open(
                            trackingUrl,
                            "ShippingStatusPopup",
                            popupOptions
                          );
                        }
                      }}
                    >
                      {data.metadata?.shipping
                        ? data.metadata.shipping
                        : "미지정"}
                    </P>
                  )}
                </FlexChild>
              </FlexChild>
            </HorizontalFlex>
            <HorizontalFlex justifyContent="flex-start" alignItems="flex-start">
              <FlexChild>
                <FlexChild width="100px">
                  <P weight="bold">결제상태</P>
                </FlexChild>
                <FlexChild width="max-content">
                  <P>{t(data.payment_status)}</P>
                </FlexChild>
              </FlexChild>
              <FlexChild>
                <VerticalFlex>
                  <HorizontalFlex justifyContent="flex-start">
                    <FlexChild width="100px">
                      <P weight="bold">결제금액</P>
                    </FlexChild>
                    <FlexChild width="max-content">
                      <P>
                        {data.payments?.[0]?.amount
                          ? Number(data.payments?.[0]?.amount).toLocaleString(
                              "kr"
                            )
                          : "오류"}
                        
                      </P>
                    </FlexChild>
                  </HorizontalFlex>
                  <HorizontalFlex justifyContent="flex-start">
                    <FlexChild width="100px">
                      <P weight="bold">사용된 포인트</P>
                    </FlexChild>
                    <FlexChild width="max-content">
                      <P>{data?.metadata?.point || 0}P</P>
                    </FlexChild>
                  </HorizontalFlex>
                </VerticalFlex>
              </FlexChild>
            </HorizontalFlex>
            <HorizontalFlex>
              <FlexChild width="100px" alignItems={"flex-start"}>
                <P weight="bold">관리자 메모</P>
              </FlexChild>
              <FlexChild>
                {editable ? (
                  <InputTextarea
                    ref={(el) => (inputs.current[5] = el)}
                    validable={false}
                    rows={2}
                    name="메모"
                    style={{ fontSize: 14, color: "red" }}
                    value={data.metadata?.memo}
                  />
                ) : (
                  <P color={data?.metadata?.memo && "red"}>
                    {data?.metadata?.memo ? data.metadata.memo : "없음"}
                  </P>
                )}
              </FlexChild>
            </HorizontalFlex>
          </VerticalFlex>
          <HorizontalFlex justifyContent="center" gap={20}>
            <FlexChild width="max-content">
              {editable ? (
                <AdminCustomButton text="저장" onClick={save} />
              ) : (
                <AdminCustomButton
                  text="수정"
                  onClick={() => setEditable(true)}
                />
              )}
            </FlexChild>
            .
            <FlexChild width="max-content">
              {editable ? (
                <AdminCustomButton text="취소" onClick={reset} />
              ) : (
                <AdminCustomButton
                  text="닫기"
                  onClick={() => modal.current.close()}
                />
              )}
            </FlexChild>
          </HorizontalFlex>
        </VerticalFlex>
      </div>
    </ModalBase>
  );
});

export default OrderDetailModal;
